import React from 'react';

/**
 * Fixed "Dev Env" badge shown in the bottom-right corner during local development.
 * Renders only in development builds — `npm run build` sets NODE_ENV=production,
 * so this returns null and never ships in the production bundle.
 */
const DevWatermark: React.FC = () => {
  if (process.env.NODE_ENV === 'production') return null;

  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        right: 12,
        bottom: 12,
        zIndex: 9999,
        pointerEvents: 'none',
        userSelect: 'none',
        padding: '4px 10px',
        borderRadius: 6,
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: '#fff',
        background: 'rgba(178, 34, 34, 0.85)',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
      }}
    >
      Dev Env
    </div>
  );
};

export default DevWatermark;
